import { ShieldCheck, Shield, Briefcase, User } from "lucide-react";

export const roleConfig = {
  SUPER_ADMIN: {
    icon: ShieldCheck,
    className: "bg-primary_tint text-primary border-primary",
    label: "Super Admin",
  },
  ADMIN: {
    icon: Shield,
    className: "bg-danger_bg text-danger border-danger_border",
    label: "Admin",
  },
  CLIENT: {
    icon: Briefcase,
    className: "bg-info_bg text-info border-info_border",
    label: "Client",
  },
  EMPLOYEE: {
    icon: User,
    className: "bg-success_bg text-success border-success_border",
    label: "Employee",
  },
};

export const getRoleConfig = (role) =>
  roleConfig[role] || { icon: User, className: "bg-surface_alt text-text_secondary border-border", label: role || "Unknown" };
